module.exports = __webpack_public_path__ + "img/bg2.214c63b1.png";